module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm._l((_vm.stats), function(data, key) {
    return _c('stats-info', {
      key: key,
      staticClass: "stats-info",
      attrs: {
        "icon": data.icon,
        "title": data.title,
        "description": _vm.$t("fn.complex.stats-description", {
          name: data.slug
        }),
        "value": _vm.statValue(data.slug, data.value),
        "details": data.details
      }
    })
  }), (!_vm.isOneOff && _vm.currentIteration) ? _c('div', [_c('h4', {
    staticClass: "section-subtitle mt-6",
    staticStyle: {
      "font-size": "14px",
      "margin-top": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.your-current-flight')) + " (" + _vm._s(_vm.$t('pos.campaign.started')) + " " + _vm._s(_vm.currentIterationStartDay) + ")")]), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.change-flight-hint')))]), _c('div', {
    staticClass: "row mt-3",
    attrs: {
      "data-campaign-stats": "all"
    }
  }, _vm._l((_vm.currentIterationStats), function(data, key) {
    return _c('div', {
      key: key,
      class: data.details ? 'col-md-12' : _vm.colWidth
    }, [_c('stats-info', {
      staticClass: "stats-info",
      attrs: {
        "icon": data.icon,
        "title": data.title,
        "value": _vm.statValue(data.slug, data.value),
        "details": data.details,
        "size": "md"
      }
    })], 1)
  }))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-052690de"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-stats/CampaignStats.vue
// module id = 1998
// module chunks = 1